<template>
    <div class="col-md-9 text-normal details-text" 
    v-if="currentUserMap"
    v-html="currentUserMap.content ? currentUserMap.content.rendered : ''"></div>
</template>

<script>
export default {
    name: "ExecContentDetails",
    props: ['currentUserMap']
}
</script>